import {BusEvent, Dispatcher, DispatcherPriority, EventBus} from 'dispatcher'
import {Command} from './WSCMD'
import {
  ACTICE_CONVERSATION_TYPE,
  CHAT_ERROR_TYPE,
  WS_ACTIVE_CONVERSATION_DATA,
  WS_CHAT_TYPE_VALUE,
  WS_CHAT_VALUE_CMD_R
} from 'ws'

export class ActiveCommand extends Command<
  WS_ACTIVE_CONVERSATION_DATA,
  undefined
> {
  protected uuid = this.eventBus.generateUUID()
  protected cmd = 'get.chats/active+unseen'
  protected meta = undefined
  protected data = {}
  protected dispatcher: Dispatcher<WS_ACTIVE_CONVERSATION_DATA, undefined> =
    new (class extends Dispatcher<WS_ACTIVE_CONVERSATION_DATA, undefined> {
      constructor(
        private uuid: string,
        eventBus: EventBus
      ) {
        super(eventBus)
      }

      protected consumable: boolean = true

      protected criteria(
        event: BusEvent<WS_ACTIVE_CONVERSATION_DATA, undefined>
      ): boolean {
        return (
          event.type === WS_CHAT_TYPE_VALUE &&
          (event.data?.type === ACTICE_CONVERSATION_TYPE ||
            event.data?.type === CHAT_ERROR_TYPE) &&
          event.data?.meta.event.type === WS_CHAT_VALUE_CMD_R &&
          event.data?.meta.event.meta.id === this.uuid
        )
      }

      protected priority: DispatcherPriority = 'COMMAND'
    })(this.uuid, this.eventBus)

  constructor(protected eventBus: EventBus) {
    super(eventBus)
  }
}
